<template>
  <main class="w-full max-w-none">
    <div class="mx-auto w-full max-w-full px-0">
      <div class="mb-8">
        <h1 class="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
          查询签约状态/流水同步状态
        </h1>
        <p class="text-gray-600">查询指定客户的签约状态和数据同步状态</p>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-5 gap-3 w-full">
        <!-- 左侧内容 -->
        <div class="w-full lg:col-span-3">
          <Card class="mb-8">
            <CardHeader>
              <CardTitle>接口说明</CardTitle>
              <CardDescription>
                客户号查询签约/数据同步状态接口用于获取指定客户的签约状态和数据同步状态信息。
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div
                class="flex items-center gap-4 mb-6 p-4 bg-gray-50 rounded-lg"
              >
                <span
                  class="px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full"
                  >GET</span
                >
                <code class="text-sm font-mono"
                  >/api/v2/customer/syncDataInfo</code
                >
              </div>

              <div class="space-y-6">
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求头参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-id
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            APP ID
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            4d9414e89bc24b0d89b678d9f20bc56a
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-secret
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            API Key
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            8201e508ef948b8fcdca855729e7ee34
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-customer-code
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            客户编号
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            CUSTFA48DD8EFF437956
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    响应参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            code
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            返回状态 200成功
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            data.syncDataStatus
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            Number
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            状态：0-未签约，1-签约中,
                            2-签约成功，3-数据同步中，4-数据同步完成
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            message
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            失败时返回错误信息
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            realJsonModel
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            返回json，true
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            status
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            http状态码
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            successResponse
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            Boolean
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            成功返回
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    状态码说明
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            状态码
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            0
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            未签约
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            1
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            签约中
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            2
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            签约成功
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            3
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            数据同步中
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            4
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            数据同步完成
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <!-- 右侧"试一试"区域 -->
        <div class="w-full lg:col-span-2">
          <Card>
            <CardHeader>
              <CardTitle>试一试</CardTitle>
              <CardDescription>使用不同语言测试API</CardDescription>
            </CardHeader>
            <CardContent>
              <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-8 overflow-x-auto">
                  <button
                    v-for="language in languages"
                    :key="language.id"
                    @click="activeLanguage = language.id"
                    class="whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
                    :class="[
                      activeLanguage === language.id
                        ? 'border-[var(--primary)] text-[var(--primary)]'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                    ]"
                  >
                    {{ language.name }}
                  </button>
                </nav>
              </div>

              <div class="mt-6">
                <pre
                  class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"
                ><code>{{ getRequestText() }}</code></pre>
                <div class="space-y-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-id</label
                    >
                    <input
                      v-model="appId"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-secret</label
                    >
                    <input
                      v-model="authorization"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-customer-code</label
                    >
                    <input
                      v-model="customerCode"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <button
                    @click="queryCustomerStatus"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[var(--primary)] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {{ loading ? "查询中..." : "查询状态" }}
                  </button>
                </div>
              </div>

              <!-- 响应结果 -->
              <div v-if="response" class="mt-6">
                <h3 class="text-lg font-medium text-gray-900 mb-2">响应结果</h3>
                <pre
                  class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"
                ><code>{{ response }}</code></pre>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, nextTick } from "vue";
import Sidebar from "./Sidebar.vue";
import Card from "./ui/Card.vue";
import CardHeader from "./ui/CardHeader.vue";
import CardTitle from "./ui/CardTitle.vue";
import CardDescription from "./ui/CardDescription.vue";
import CardContent from "./ui/CardContent.vue";
import { useCodeHighlight } from "@/composables/useCodeHighlight";
import httpService from "@/lib/http";
import hljs from "highlight.js/lib/core";
import { useSystemStore } from "@/stores/system";
// 使用代码高亮
const highlightCode = () => {
  nextTick(() => {
    // 等待DOM更新完成后再处理
    setTimeout(() => {
      // 找到所有代码块
      const allCodeBlocks = document.querySelectorAll("pre code");

      // 语言映射表
      const languageMap: { [key: string]: string } = {
        curl: "language-bash",
        javascript: "language-javascript",
        python: "language-python",
        java: "language-java",
        csharp: "language-csharp",
        php: "language-php",
        ruby: "language-ruby",
      };

      const langClass = languageMap[activeLanguage.value];

      // 处理所有代码块
      allCodeBlocks.forEach((block) => {
        // 清除之前的高亮
        block.className = "";
        block.removeAttribute("data-highlighted");

        // 重新添加基础类和语言类
        block.classList.add("hljs");
        if (langClass) {
          block.classList.add(langClass);
        }

        try {
          hljs.highlightElement(block as HTMLElement);
        } catch (error) {
          console.warn("代码高亮失败:", error);
        }
      });
    }, 100); // 减少延迟时间
  });
};

// 初始化代码高亮
highlightCode();

// 系统配置
const systemStore = useSystemStore();

// 默认值
const DEFAULT_APP_ID = "登录后自动获取";
const DEFAULT_APP_SECRET = "登录后自动获取";
const DEFAULT_CUSTOMER_CODE = "登录后自动获取";

const appId = ref(DEFAULT_APP_ID);
const authorization = ref(DEFAULT_APP_SECRET);
const customerCode = ref(DEFAULT_CUSTOMER_CODE);
const loading = ref(false);
const response = ref("");
const activeLanguage = ref("curl");

// 获取应用信息
const getApplicationInfo = async () => {
  try {
    const response = await httpService.get<any>("/nxb/console/application/get");

    if (response) {
      return {
        appId: response.appId,
        appSecret: response.appSecret,
      };
    }
    return null;
  } catch (error) {
    console.log("获取应用信息失败:", error);
    return null;
  }
};

// 获取客户信息
const getCustomerInfo = async () => {
  try {
    const response = await httpService.get<any>(
      "/nxb/console/customer/listWithSummary",
      {
        pageNow: 1,
        pageSize: 10,
      }
    );

    if (response) {
      return response.customers[0].customerCode;
    }
    return null;
  } catch (error) {
    console.log("获取客户信息失败:", error);
    return null;
  }
};

// 登录后自动获取用户信息
const autoFetchUserInfo = async () => {
  const userInfoStr = localStorage.getItem("userInfo");

  if (userInfoStr) {
    // 获取应用信息
    const appInfo = await getApplicationInfo();

    if (appInfo) {
      appId.value = appInfo.appId;
      authorization.value = appInfo.appSecret;
    }

    // 获取客户信息
    const customerCodeValue = await getCustomerInfo();
    if (customerCodeValue) {
      customerCode.value = customerCodeValue;
    }
  }
};

// 组件挂载时登录后自动获取用户信息
onMounted(() => {
  autoFetchUserInfo();
});

// 监听响应式变量变化，重新应用代码高亮
watch(
  [appId, authorization, customerCode, activeLanguage, response],
  () => {
    highlightCode();
  },
  { flush: "post" }
);

// 语言选项
const languages = [
  { id: "curl", name: "cURL" },
  { id: "javascript", name: "JavaScript" },
  { id: "python", name: "Python" },
  { id: "java", name: "Java" },
  { id: "csharp", name: "C#" },
  { id: "php", name: "PHP" },
  { id: "ruby", name: "Ruby" },
];

// 获取请求文本
const getRequestText = () => {
  const headers = {
    "x-app-id": appId.value,
    "x-app-secret": authorization.value,
    "x-customer-code": customerCode.value,
  };

  switch (activeLanguage.value) {
    case "curl":
      return (
        `curl -X GET '${
          import.meta.env.VITE_API_URL
        }/api/v2/customer/syncDataInfo' \\\n` +
        `  -H 'x-app-id: ${appId.value}' \\\n` +
        `  -H 'x-app-secret: ${authorization.value}' \\\n` +
        `  -H 'x-customer-code: ${customerCode.value}'`
      );

    case "javascript":
      return (
        `const axios = require('axios');\n\n` +
        `const config = {\n` +
        `  method: 'get',\n` +
        `  url: '${
          import.meta.env.VITE_API_URL
        }/api/v2/customer/syncDataInfo',\n` +
        `  headers: { \n` +
        `    'x-app-id': '${appId.value}',\n` +
        `    'x-app-secret': '${authorization.value}',\n` +
        `    'x-customer-code': '${customerCode.value}'\n` +
        `  }\n` +
        `};\n\n` +
        `axios(config)\n` +
        `  .then(function (response) {\n` +
        `    console.log(JSON.stringify(response.data));\n` +
        `  })\n` +
        `  .catch(function (error) {\n` +
        `    console.log(error);\n` +
        `  });`
      );

    case "python":
      return (
        `import requests\n\n` +
        `url = "${
          import.meta.env.VITE_API_URL
        }/api/v2/customer/syncDataInfo"\n\n` +
        `headers = {\n` +
        `  'x-app-id': '${appId.value}',\n` +
        `  'x-app-secret': '${authorization.value}',\n` +
        `  'x-customer-code': '${customerCode.value}'\n` +
        `}\n\n` +
        `response = requests.request("GET", url, headers=headers)\n\n` +
        `print(response.text)`
      );

    case "java":
      return (
        `OkHttpClient client = new OkHttpClient().newBuilder()\n` +
        `  .build();\n` +
        `Request request = new Request.Builder()\n` +
        `  .url("${
          import.meta.env.VITE_API_URL
        }/api/v2/customer/syncDataInfo")\n` +
        `  .method("GET", null)\n` +
        `  .addHeader("x-app-id", "${appId.value}")\n` +
        `  .addHeader("x-app-secret", "${authorization.value}")\n` +
        `  .addHeader("x-customer-code", "${customerCode.value}")\n` +
        `  .build();\n` +
        `Response response = client.newCall(request).execute();`
      );

    case "csharp":
      return (
        `var client = new RestClient("${
          import.meta.env.VITE_API_URL
        }/api/v2/customer/syncDataInfo");\n` +
        `var request = new RestRequest(Method.GET);\n` +
        `request.AddHeader("x-app-id", "${appId.value}");\n` +
        `request.AddHeader("x-app-secret", "${authorization.value}");\n` +
        `request.AddHeader("x-customer-code", "${customerCode.value}");\n` +
        `IRestResponse response = client.Execute(request);\n` +
        `Console.WriteLine(response.Content);`
      );

    case "php":
      return (
        `<?php\n\n` +
        `$curl = curl_init();\n\n` +
        `curl_setopt_array($curl, array(\n` +
        `  CURLOPT_URL => '${
          import.meta.env.VITE_API_URL
        }/api/v2/customer/syncDataInfo',\n` +
        `  CURLOPT_RETURNTRANSFER => true,\n` +
        `  CURLOPT_ENCODING => '',\n` +
        `  CURLOPT_MAXREDIRS => 10,\n` +
        `  CURLOPT_TIMEOUT => 0,\n` +
        `  CURLOPT_FOLLOWLOCATION => true,\n` +
        `  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,\n` +
        `  CURLOPT_CUSTOMREQUEST => 'GET',\n` +
        `  CURLOPT_HTTPHEADER => array(\n` +
        `    'x-app-id: ${appId.value}',\n` +
        `    'x-app-secret: ${authorization.value}',\n` +
        `    'x-customer-code: ${customerCode.value}'\n` +
        `  ),\n` +
        `));\n\n` +
        `$response = curl_exec($curl);\n\n` +
        `curl_close($curl);\n` +
        `echo $response;`
      );

    case "ruby":
      return (
        `require "uri"\n` +
        `require "net/http"\n\n` +
        `url = URI("${
          import.meta.env.VITE_API_URL
        }/api/v2/customer/syncDataInfo")\n\n` +
        `https = Net::HTTP.new(url.host, url.port);\n` +
        `https.use_ssl = true\n\n` +
        `request = Net::HTTP::Get.new(url)\n` +
        `request["x-app-id"] = "${appId.value}"\n` +
        `request["x-app-secret"] = "${authorization.value}"\n` +
        `request["x-customer-code"] = "${customerCode.value}"\n\n` +
        `response = https.request(request)\n` +
        `puts response.read_body`
      );

    default:
      return "";
  }
};

// cURL方式查询客户状态
const queryCustomerStatus = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/customer/syncDataInfo", {
      method: "GET",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
      },
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// JavaScript方式查询客户状态
const queryCustomerStatusJS = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const config = {
      method: "GET",
      url: "/api/v2/customer/syncDataInfo",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
      },
    };

    const res = await fetch(config.url, {
      method: config.method,
      headers: config.headers,
    });

    const responseData = await res.json();
    response.value = JSON.stringify(responseData, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// Python方式查询客户状态
const queryCustomerStatusPython = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/customer/syncDataInfo", {
      method: "GET",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
      },
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// Java方式查询客户状态
const queryCustomerStatusJava = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/customer/syncDataInfo", {
      method: "GET",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
      },
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// C#方式查询客户状态
const queryCustomerStatusCSharp = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/customer/syncDataInfo", {
      method: "GET",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
      },
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// PHP方式查询客户状态
const queryCustomerStatusPHP = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/customer/syncDataInfo", {
      method: "GET",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
      },
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// Ruby方式查询客户状态
const queryCustomerStatusRuby = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/customer/syncDataInfo", {
      method: "GET",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
      },
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
/* 添加任何需要的自定义样式 */
</style>
